var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redeemable-services"},[_vm._l((_vm.services),function(item,indx){return _c('service-breakdown-card',{key:indx,attrs:{"item":item,"service":item.service,"items":item.redeemable_services}})}),(_vm.services.length === 0)?_c('eden-content-empty',{attrs:{"text":'No Redeemable services',"size":120}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }